export const MODE_STATES = {
  noModes: 'no_modes',
  noCertificates: 'no_certificates',
  view: 'view',
  editAll: 'edit_all',
  create: 'create',
} as const;

export const ACTIVATION_MESSAGES = {
  activating: 'Activating',
  deactivating: 'Deactivating',
};
